
const data = {

    page: {
        aniresan:'آنی رسان',
        home: 'خانه',
        profile: 'پروفایل',
        changePass: 'تغییر کلمه عبور',
        notFound: 'صفحه ای یافت نشد',
        news:'اخبار',
        Complaint:'ثبت شکایت',
        faq:'سوالات متداول',
        Allnews:'تازه های آنی رسان'
	},

    error: {
        chackForm: 'لطفا ابتدا خطاهای فرم را بررسی  و رفع نمایید.',
        required: 'فیلد {label} اجباری است',
        invalid: 'فیلد {label} نامعتبر است',
    },

    global: {
        applicationName:'آنی رسان'
    },

    site:{
        news:{
            label: 'تازه های آنی رسان'
        },
        question:{
            label:'سوالات متداول'

        },
        aboutus:{
            label:'درباره آنی رسان'
        },
        delivery:{
            label:'مراحل ثبت مرسوله در آنی رسان'
        },
        services:{
            label:'خدمات آنی رسان'
        },
        Allnews:{
            label:'اخبار و تازه های آنی رسان'

        }
    }

};




const resources = (path, value) =>
{
    path = path || '';

    var current = '';

    if (Array.isArray(path))
    {
        for (var item of path)
            current += resources(item) + ' ';
    }
    else
    {
        current = data;
        path.split('.').forEach(function (p)
        {
            current = (current[p] != undefined) ? current[p] : path;
        });
    }

    if (current && typeof value == 'object')
    {
        for (let param in value)
            current = current.replace('{' + param + '}', value[param])
    }

    return current;
};

export default resources;
